import { useState, useEffect } from 'react';
import useSWR, { mutate } from 'swr';

import { SESSION_TIMEOUT, FOCUS_THROTTLE_INTERVAL } from '@/config/appSettings';

import { IResponseError } from '@/lib/apiBase';
import { IRepository } from '@/types';
import { IDataFrameResponse } from '@/lib/dataFrameTypes';
import { fetchEvaluationSampleDataframe } from '@/lib/evaluationsApi';

// const revalidate = (orgname: string) => {
//   const key = ['organization', orgname];
//   // console.log('revalidate > key', key);
//   mutate(key, undefined, { revalidate: true });
// };

const useSampleDataframe = ({
  repository,
  evaluationId,
  initialData,
  status,
}: {
  repository: IRepository;
  evaluationId: string;
  initialData?: IDataFrameResponse;
  status?: string;
}) => {
  const [error, setError] = useState<IResponseError | undefined>();
  const fetchKey = ['sampleDataframe', evaluationId];

  const {
    data,
    error: requestError,
    isLoading,
    isValidating,
    mutate,
  } = useSWR(fetchKey, () => fetchEvaluationSampleDataframe({ repository, evaluationId }), {
    fallbackData: initialData,
    keepPreviousData: true,
    revalidateOnFocus: false,
    revalidateOnMount: !initialData,
    revalidateOnReconnect: false,
    focusThrottleInterval: FOCUS_THROTTLE_INTERVAL,
    refreshInterval: status === 'completed' ? undefined : 1000,
  });

  const revalidate = () => {
    mutate();
  };

  return { data, error, revalidate };
};

export default useSampleDataframe;
